import { useState, type ReactNode } from "react";
import { PageContainer } from "@/app/layouts/PageContainer";
import { IntentButton } from "@/components/intent-button";

export interface WizardStep { id: string; label: string; render: () => ReactNode; }
export interface WizardProps {
  steps: readonly WizardStep[];
  onSaveDraft?: () => void;
  onFinish: () => void;
}

export function Wizard({ steps, onSaveDraft, onFinish }: WizardProps) {
  const [index, setIndex] = useState(0);
  const step = steps[index]!;
  return (
    <PageContainer>
      <ol className="mb-4 flex gap-2 text-sm">
        {steps.map((s, i) => (
          <li key={s.id} className={i === index ? "font-semibold" : "text-muted-foreground"}>
            {i + 1}. {s.label}
          </li>
        ))}
      </ol>
      <div>{step.render()}</div>
      <div className="mt-6 flex justify-between">
        <IntentButton intent="ghost" disabled={index === 0} onClick={() => setIndex(index - 1)}>Back</IntentButton>
        <div className="flex gap-2">
          {onSaveDraft ? <IntentButton intent="secondary" onClick={onSaveDraft}>Save draft</IntentButton> : null}
          {index < steps.length - 1 ? (
            <IntentButton onClick={() => setIndex(index + 1)}>Next</IntentButton>
          ) : (
            <IntentButton onClick={onFinish}>Finish</IntentButton>
          )}
        </div>
      </div>
    </PageContainer>
  );
}
